module.exports = __webpack_public_path__ + "static/media/promo.03e7c1ae.png";